"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stack_utils_exports = {};
__export(stack_utils_exports, {
  BottomToolbarHost: () => import_StackToolbarBottomHost.BottomToolbarHost,
  StackHeader: () => StackHeader,
  StackHeaderBackButton: () => import_StackHeaderBackButton.StackHeaderBackButton,
  StackHeaderComponent: () => import_StackHeaderComponent.StackHeaderComponent,
  StackHeaderLeft: () => import_StackHeaderLeft.StackHeaderLeft,
  StackHeaderRight: () => import_StackHeaderRight.StackHeaderRight,
  StackHeaderSearchBar: () => import_StackHeaderSearchBar.StackHeaderSearchBar,
  StackHeaderTitle: () => import_StackHeaderTitle.StackHeaderTitle,
  StackScreen: () => import_StackScreen.StackScreen,
  StackToolbarBadge: () => import_StackToolbar.StackToolbarBadge,
  StackToolbarButton: () => import_StackToolbar.StackToolbarButton,
  StackToolbarComponent: () => import_StackToolbar.StackToolbarComponent,
  StackToolbarIcon: () => import_StackToolbar.StackToolbarIcon,
  StackToolbarLabel: () => import_StackToolbar.StackToolbarLabel,
  StackToolbarMenu: () => import_StackToolbar.StackToolbarMenu,
  StackToolbarMenuAction: () => import_StackToolbar.StackToolbarMenuAction,
  StackToolbarSearchBarSlot: () => import_StackToolbar.StackToolbarSearchBarSlot,
  StackToolbarSpacer: () => import_StackToolbar.StackToolbarSpacer,
  appendScreenStackPropsToOptions: () => import_StackScreen.appendScreenStackPropsToOptions,
  appendStackToolbarPropsToOptions: () => import_StackToolbar.appendStackToolbarPropsToOptions,
  validateStackPresentation: () => import_StackScreen.validateStackPresentation
});
module.exports = __toCommonJS(stack_utils_exports);
var import_StackHeaderBackButton = require("./StackHeaderBackButton");
var import_StackHeaderComponent = require("./StackHeaderComponent");
var import_StackHeaderLeft = require("./StackHeaderLeft");
var import_StackHeaderRight = require("./StackHeaderRight");
var import_StackHeaderSearchBar = require("./StackHeaderSearchBar");
var import_StackHeaderTitle = require("./StackHeaderTitle");
var import_children = require("../../headless/children");
var import_StackScreen = require("./StackScreen");
var import_StackToolbarBottomHost = require("./StackToolbarBottomHost");
var import_StackToolbar = require("./StackToolbar");
var StackHeader = Object.assign(import_StackHeaderComponent.StackHeaderComponent, {
  [import_children.NAVIGATOR_CONFIG]: true,
  Left: import_StackHeaderLeft.StackHeaderLeft,
  Right: import_StackHeaderRight.StackHeaderRight,
  BackButton: import_StackHeaderBackButton.StackHeaderBackButton,
  Title: import_StackHeaderTitle.StackHeaderTitle,
  SearchBar: import_StackHeaderSearchBar.StackHeaderSearchBar
});
//# sourceMappingURL=index.js.map
